var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-row section-heading"},_vm._l((_vm.data.value),function(item,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }